<template>

    <div class="columns is-multiline round-editor">
        <div v-if="competition.competitors.length" class="round-message">

        </div>
        <div class="column is-half round-date-wrap" v-for="dt in dates" :key="dt.label">
            <div class="round-pad">
                <span class="round-date">{{dt.label}}</span>
                <div class="round-panel" v-for="r in competition.rounds.filter(x=>{ return format(new Date(x.start)) == dt.label })" :key="r.id">
                    <div class="round-header">
                        <span class="round-name">{{r.name}}</span> <span class="round-time">{{time(r.start)}} - {{ time(r.end) }}</span> 
                    </div>
                    <div class="round-class" v-for="fr in flatrounds.filter(x=>x.roundid == r.id)" :key="fr.key">
                        <span class="round-class-label"> {{fr.label}} </span>
                        <span class="round-class-total">{{ fr.count }}</span>
                        <b-button @click="$router.push({ path: `/scoring/${competition.key}/${fr.racid}`})" :class="{'v-hidden':fr.count==0}" :disabled="fr.count==0" type="is-info" class=" goto-scoring">Do Scoring</b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex';

export default {
    name: 'EditRounds',
    components: {

    },
    data: function() {
        return {

        }
    },
    computed: {
        ...mapGetters({ competition: 'backend/competition'}),
        ...mapGetters({ dates: 'backend/dates'}),
        ...mapGetters({ flatrounds: 'backend/flatrounds'})
    },
    methods: {
        format(str) {
            return moment(str).format('ddd Do MMM YYYY')
        },
        time(str) {
            return moment(str).format('HH:mm')
        }
    },
}
</script>

<style>
.v-hidden { visibility: hidden; }
.goto-scoring { margin-left: 0.5rem; }
.round-panel { margin-bottom: 2rem; }
.round-name { font-size: 1.2rem; }
.round-header { display: flex; align-items: center; box-shadow: #ddd 0px 1px; margin-bottom: 0.5rem; }
.round-time { margin-left: auto; }
.round-editor { transform: translateY(2rem); }
.round-date-wrap { margin-top: 2rem;  padding: 1rem; position: relative; }
.round-class { display: flex; align-items: center; padding: 0.25rem 0 0; }
.round-class-label { font-display: initial; }
.round-class-total { margin-left: auto; }
.round-date { 
    position: absolute;
    left: 0.75rem;
    top: -1.75rem;
    background: #ebebeb;
    padding: 0.5rem 1rem;
}
.round-pad { padding:2rem 1rem; background: #FFF; }
@media (min-width: 768px ){

}
</style>
